export type TweetForm = {
  body: string;
};

export const emptyTweetForm = (): TweetForm => ({
  body: '',
});

export const tweetToForm = (tweet: { body?: string;}): TweetForm => ({
  body: tweet.body ?? '',
});

export const parseTweetForm = (form: TweetForm): { body: string;} | null => {
  const body = form.body.trim();
  if (!body) {
    alert('つぶやきを入力してください。');
    return null;
  }

  if (body.length > 500) {
    alert('つぶやきは500文字以内で入力してください。');
    return null;
  }

  return {
    body,
  };
};
